import wechatAuth from './wechatAuth';
import {getUrlParmas} from "@/util/tool"
export default {
    install(Vue, options) {
        //alert("index.js")
        let router = options.router;
        let wechatPlugin = new wechatAuth(options)
        if (!router) return false;
        //绑定到路由上
        router.beforeEach((to, from, next) => {
            alert(to.path)
            /*if(to.path == "/index"){
                next();
                return
            }*/
            //localStorage.setItem('wxGzhTrolleyOldPath',to.fullPath)
            let query = getUrlParmas();
            let code = query.code;
            /*let wxGzhTrolleyUserInfo = window.localStorage.getItem('wxGzhTrolleyUserInfo');
            if(wxGzhTrolleyUserInfo){
                wxGzhTrolleyUserInfo = JSON.parse(wxGzhTrolleyUserInfo);
                if(wxGzhTrolleyUserInfo.exist == "false"){
                    next("/index");
                    return
                }
            }*/
            if (window.localStorage.getItem('wxGzhTrolleyCode')) {// 判断是否已经有授权
                next();
            } else if (code) {
                wechatPlugin.getCodeCallback(next, code);
            } else { //去获取code
                wechatPlugin.getCode();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/util/wechatAuth/index.js